var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PlantDetailForm',{attrs:{"mode":"create"},on:{"submit":_vm.onSubmit,"abort":_vm.onAbort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }